import { render, staticRenderFns } from "./Group.vue?vue&type=template&id=f37ae8a8&scoped=true&"
import script from "./Group.js?vue&type=script&lang=js&"
export * from "./Group.js?vue&type=script&lang=js&"
import style0 from "./Group.vue?vue&type=style&index=0&id=f37ae8a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37ae8a8",
  null
  
)

export default component.exports